"use strict";

exports.__esModule = true;
exports["default"] = exports.MappedSlideIn = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

var _utils = require("../../utils");

var _excluded = ["children", "in", "isOpen"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var mappedSlideInpropTypes = {
  children: _propTypes.node,
  "in": _propTypes.bool,
  isOpen: _propTypes.bool
};

var MappedSlideIn = function MappedSlideIn(_ref) {
  var children = _ref.children,
      animateIn = _ref["in"],
      isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_animations.SlideIn, _extends({}, props, {
    animateIn: animateIn,
    show: animateIn && isOpen
  }), children);
};

exports.MappedSlideIn = MappedSlideIn;
MappedSlideIn.propTypes = mappedSlideInpropTypes;
var propTypes = {
  /** Object map of filters currently active */
  activeFilters: (0, _propTypes.objectOf)(_propTypes.string),
  // Checkbox font props
  checkFontObject: _utils.fontPropType,
  // Object map of filters currently disabled
  disabledFilters: (0, _propTypes.objectOf)(_propTypes.string),

  /** onChange event handler - used to process the filter selection event */
  filterOnChange: _propTypes.func,
  // Object map of parent nested filter
  parentFilter: (0, _propTypes.shape)({
    filters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
    })),
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })
};
var defaultProps = {
  activeFilters: {},
  disabledFilters: {}
};

var NestedCheckboxFilters = function NestedCheckboxFilters(_ref2) {
  var activeFilters = _ref2.activeFilters,
      checkFontObject = _ref2.checkFontObject,
      disabledFilters = _ref2.disabledFilters,
      filterOnChange = _ref2.filterOnChange,
      parentFilter = _ref2.parentFilter;

  var _useToggle = (0, _utils.useToggle)(false),
      isNestedShown = _useToggle[0],
      onNestedCheckToggleClick = _useToggle[1];

  var nestedCheckFontObject = (0, _ramda.merge)(checkFontObject, {
    color: "blue",
    fontWeight: "bold"
  });

  var nestedActiveCheck = function nestedActiveCheck(parent) {
    var checkStatusArray = [];
    (0, _ramda.map)(function (filter) {
      if (!(filter.chidren && filter.chidren.length)) {
        checkStatusArray = [].concat(checkStatusArray, [activeFilters[filter.value] ? 1 : 0]);
      } else {
        checkStatusArray = [].concat(checkStatusArray, nestedActiveCheck(filter));
      }
    }, parent.chidren);
    return checkStatusArray;
  };

  var nestedActiveCheckList = nestedActiveCheck(parentFilter);
  var sumOfNestedActivCheck = (0, _ramda.sum)(nestedActiveCheckList);
  var isChecked = sumOfNestedActivCheck === nestedActiveCheckList.length;
  var intermediate = sumOfNestedActivCheck > 0 && !isChecked;
  /**
   * If parent is calculated to be checked using child check selection using recursion ,
   * but is not in active filter then add tp active filter
   */

  if (isChecked && !activeFilters[parentFilter.value]) {
    filterOnChange(Object.assign({
      event: {}
    }, parentFilter));
  }

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    py: [0, 2, 1]
  }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    checkboxOnChange: function checkboxOnChange(event) {
      return filterOnChange(Object.assign({
        event: event
      }, parentFilter));
    },
    checkBoxWidth: [20, 20, 16],
    checkFontObject: nestedCheckFontObject,
    disabled: disabledFilters[parentFilter.value],
    flexDirection: ["row-reverse", "row-reverse", "row"],
    indeterminate: intermediate,
    isChecked: isChecked,
    isChildShown: isNestedShown,
    isNested: true,
    justifyContent: ["space-between", "space-between", "flex-start"],
    label: parentFilter.label,
    mr: [0, 0, 1],
    onNestedCheckToggle: onNestedCheckToggleClick,
    py: ["15px", 0, 0],
    value: parentFilter.value,
    width: 1
  }), isNestedShown && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    ml: 3,
    mr: [3, 3, 0],
    pt: 1
  }, /*#__PURE__*/_react["default"].createElement(_animations.TransitionGroup, {
    component: _primitives["default"].Box
  }, (0, _utils.mapIndexed)(function (filter, index) {
    return /*#__PURE__*/_react["default"].createElement(MappedSlideIn, {
      key: filter.id,
      alwaysShowInDom: true,
      delayIn: index * 0.04,
      delayOut: (parentFilter.chidren.length - index) * 0.04,
      enterDuration: 0.25,
      exitDuration: 0.25,
      fadeInOut: true,
      isOpen: isNestedShown,
      vertical: -0.5
    }, !(filter.chidren && filter.chidren.length) ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
      py: [0, 2, 1]
    }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
      checkboxOnChange: function checkboxOnChange(event) {
        return filterOnChange(Object.assign({
          event: event
        }, filter));
      },
      checkBoxWidth: [20, 20, 16],
      checkFontObject: checkFontObject,
      disabled: disabledFilters[filter.value],
      flexDirection: ["row-reverse", "row-reverse", "row"],
      isChecked: activeFilters[filter.value],
      justifyContent: ["space-between", "space-between", "flex-start"],
      label: filter.label,
      mr: [0, 0, 1],
      py: ["15px", 0, 0],
      value: filter.value,
      width: 1
    })) : /*#__PURE__*/_react["default"].createElement(NestedCheckboxFilters, {
      activeFilters: activeFilters,
      checkFontObject: checkFontObject,
      disabledFilters: disabledFilters,
      filterOnChange: filterOnChange,
      parentFilter: filter
    }));
  }, parentFilter.chidren))));
};

NestedCheckboxFilters.propTypes = propTypes;
NestedCheckboxFilters.defaultProps = defaultProps;
NestedCheckboxFilters.displayName = "Modules.NestedCheckboxFilters";
var _default = NestedCheckboxFilters;
exports["default"] = _default;